import { Component, Input } from '@angular/core';
@Component({
  selector: 'app-full-text-header',
  templateUrl: './full-text-header.component.html',
  styleUrls: ['./full-text-header.component.scss'],
  standalone: false,
})
export class FullTextHeaderComponent {
  @Input() trademarkName = '';
  constructor() {}

  public windowClose(): void {
    window.close();
  }
}
